export const referralLetterDetailsTranslations = {
    en: {
        personalDetails: "Personal Details",
        healthCamp: "Health Camp",
        tokenNo: "Token No",
        beneficiaryName: "Beneficiary Name",
        campDate: "Camp Date",
        createdBy: "Created By",
        remarks: "Remarks",

        document: "Document",
        documents: "Documents",
        noHospitalAssigned: "No Hospital Assigned",
        referralLetter: "Referral Letter",
        created: "Created",
        by: "By",
        viewPDF: "View PDF",
        download: "Download",
        noReferralDocuments: "No referral documents available",

        notAvailable: "N/A"
    },
    mr: {
        personalDetails: "वैयक्तिक तपशील",
        healthCamp: "आरोग्य शिबिर",
        tokenNo: "टोकन क्रमांक",
        beneficiaryName: "लाभार्थीचे नाव",
        campDate: "शिबिर तारीख",
        createdBy: "तयार केले",
        remarks: "शेरा",

        document: "दस्तऐवज",
        documents: "दस्तऐवज",
        noHospitalAssigned: "कोणतेही रुग्णालय नियुक्त नाही",
        referralLetter: "संदर्भ पत्र",
        created: "तयार केले",
        by: "द्वारा",
        viewPDF: "PDF पहा",
        download: "डाउनलोड करा",
        noReferralDocuments: "कोणतेही संदर्भ दस्तऐवज उपलब्ध नाहीत",

        notAvailable: "उपलब्ध नाही"
    }
};
